import React, { Component } from 'react'
import { css } from 'emotion'
import { about, interior, gallery, homebg, interiorMetrotown } from 'images'
import { MEDIA_QUERY } from 'styles'

class Promotions extends Component {
  render() {
    const { locationId } = this.props
    return (
      <div className={styles.container}>
        <img src={about} className={styles.about} alt="About" />
        <img
          src={
            locationId === 'mihbDMkGvzSmBz09dE7Z' ? interiorMetrotown : interior
          }
          className={styles.interior}
          alt="Restaurant Interior"
        />
        <img src={gallery} className={styles.gallery} alt="Food Gallery" />
      </div>
    )
  }
}

const styles = {
  container: css({
    width: '100%',
    paddingTop: '10rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '160rem',
    background: `url(${homebg}) no-repeat`,
    backgroundSize: '100% 100%',
    [MEDIA_QUERY.MD]: {
      paddingTop: '2rem',
    },
  }),
  about: css({
    objectFit: 'contain',
    paddingRight: '5rem',
    margin: '0 auto',
    width: '90%',
    [MEDIA_QUERY.MD]: {
      padding: '2rem',
    },
  }),
  interior: css({
    width: '100%',
    objectFit: 'contain',
    paddingBottom: '2rem',
  }),
  gallery: css({
    padding: '4rem',
    width: '90%',
    objectFit: 'contain',
    [MEDIA_QUERY.MD]: {
      padding: '2rem',
    },
  }),
}

export default Promotions
